import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FieldArray, FormikProvider, useFormik } from "formik";
import $ from "jquery";
import moment from "moment";
import HtmlParser from "react-html-parser";
import { useHistory, useParams } from "react-router";
import Select from "react-select";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import { GetNetsuiteItemsCancelToken } from "../../../services/CourseService";
import { AddModule, GetListofModule, updateExemptionModule, UpdateModule } from "../../../services/ProgramService";
import { RenderPMCStatus } from "../../../utils/CommonGroupingItem";
import PermissionsGate from "../../../utils/permissionGate";
import HtmlInputEditor from "../../common/HtmlInputEditor";
const statusArr = [
  {
    value: "Draft",
    label: HtmlParser(`<span class="red">Draft  </span> `)
  },
  {
    value: "New",
    label: HtmlParser(`<span class="skyblue"> New </span>`)
  },
  {
    value: "Final",
    label: HtmlParser(` <span class="green">Final</span>`)
  },
  {
    value: "Approved",
    label: HtmlParser(`<span class="yellowshade">Approved</span>`)
  },
  {
    value: "Inactive",
    label: HtmlParser(`<span class="blue">Inactive</span>`)
  },
]

const ModuleDetail = ({ detail = {}, description, setDescription, prescribedTextBooks, setPrescribedTextBooks, isEditorStateReady ,setReload}) => {
  const history = useHistory();
  const { id, type } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [moduleList, setModuleList] = useState([]);
  const [modalDuration, setModalDuration] = useState([]);
  const [isPreReqNone, setIsPreReqNone] = useState(true);
  const [isCoreqNone, setIsCoreqNone] = useState(true);
  const [netsuiteList, setNetsuiteList] = useState([]);
  const [exemptedCombination, setExemptedCombination] = useState([]);
  const [deletedCombinationGroupIds, setDeletedCombinationGroupIds] = useState([]);
  const [selectedProductData, setSelectedProductData] = useState([
    { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" },
    { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" }
  ]);
  const cancelSourcesRef = useRef([]);

  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {
      cancelTokenSources.forEach((source) => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken?.source();
      cancelTokenSources.push(source);
      try {
        const data = await GetNetsuiteItemsCancelToken(
          '',
          source.token
        );
        if (data.status === 200) {
          setNetsuiteList(
            data && data.data && data.data.data && data.data.data.items
              ? data.data.data.items
              : []
          );
          setExemptedCombination(data && data.data && data.data.data && data.data.data.items
            ? data.data.data.items
            : [])
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error('error :', error);
        }
      }
    };

    getData();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel('Component unmounted');
      });
    };
  }, []);

  useEffect(() => {
    GetListofModule()
      .then((res) => {
        let moduleData = res?.data.map((mod) => ({
          value: mod.Id,
          label: mod.Portal,
        }));
        moduleData.push({ value: 0, label: "None" })
        setModuleList(moduleData);
      })
      .catch((err) => console.error(err));
  }, []);

  usePermissionGuardRedirect(['pmcmedit']);

  useEffect(() => {
    let duration = [];
    for (let i = 1; i <= 52; i++) {
      let obj = { value: i, label: i };
      duration.push(obj);
    }
    setModalDuration(duration);
  }, []);

  const formik = useFormik({
    enableReinitialize: type === "open" || type === "duplicate" ? true : false,
    initialValues: {
      Code: detail?.Code ? detail.Code : "",
      Portal: detail?.Portal ? detail.Portal : "",
      Marketing_Name: detail?.Marketing_Name ? detail.Marketing_Name : "",
      Duration: detail?.Duration ? detail.Duration : "",
      credits: detail?.credits ? detail.credits : "",
      pre_requisites: detail?.pre_requisites && detail.pre_requisites !== "[]" && detail.pre_requisites.length > 0
        ? detail.pre_requisites
        : [0],
      co_requisites: detail?.co_requisites && detail.co_requisites !== "[]" && detail.co_requisites.length > 0
        ? detail.co_requisites
        : [0],
      prescribed_text: detail?.prescribed_text ? detail.prescribed_text : "",
      type: detail?.type ? detail.type : "",
      Module_Type: detail?.Module_Type ? detail.Module_Type : "",
      term: detail?.term ? detail?.term.split(", ") : "",
      Description: detail?.Description ? detail?.Description : "",
      module_status: detail?.module_status ? detail?.module_status : "",
      netsuite_product: detail?.netsuite_product ? detail.netsuite_product : "",
      netsuite_department_id: detail?.netsuite_department_id ? detail.netsuite_department_id : "",
      year: detail?.year ? detail.year : "",
      exemption_netsuite_ids: [],
      temporary_exemption_netsuite_ids: [],
    },
    validationSchema: Yup.object({
      Code: Yup.string()
        .max(20, "Code should not be greater than 20 Character")
        .required("Code is required")
        .trim(),
      Portal: Yup.string()
        .required("Portal Name is required").max(255, "Portal Name should not be greater than 255 Character")
        .trim(),
      module_status: Yup.string().required("Status is required"),
      term: Yup.string().required("Term is required"),
      year: Yup.string().required("Year is required"),
      type: Yup.string().required("Type is required"),
    }),
    onSubmit: (values) => {
      setDisabled(true);
      values = { ...values, pre_requisites: JSON.stringify(values.pre_requisites[0] == 0 ? [] : values.pre_requisites), co_requisites: JSON.stringify(values.co_requisites[0] == 0 ? [] : values.co_requisites) }
      values = { ...values, Description: description, prescribed_text: prescribedTextBooks }
      values = { ...values, term: values.term ? values.term.sort().join(", ") : "" };
      if (type === "open") {
        UpdateModule({ ...values, MId: id })
          .then(() => {
            setTimeout(() => {
              setReload(Date.now());
            }, 2000);
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Updated Successfully",
            });
            setDisabled(false);
            setDeletedCombinationGroupIds([]);
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.response.data,
            });
            setDisabled(false);
          });
      } else {
        if (type == "duplicate") {
          values = { ...values, duplicateId: id };
        }
        AddModule(values)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Added Successfully",
            });
            history.push("/program-management-center/modules/module/table");
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err?.response?.data?.message || "Something went wrong",
            });
          });
      }
    },
  });

  useEffect(() => {
    if (detail?.group_exemption_ids?.length > 0) {
      const groups = {};

      detail.group_exemption_ids.forEach(item => {
        const { exemption_netsuite_id, group_number, id } = item;

        // If this group doesn't exist yet, create it
        if (!groups[group_number]) {
          groups[group_number] = [];
        }

        // Add item with id also
        groups[group_number].push({
          id,
          netsuite_id: exemption_netsuite_id,
          group_number
        });
      });

      // Convert object values to an array of groups
      const finalGroups = Object.values(groups);
      formik.setFieldValue("exemption_netsuite_ids", finalGroups);
      formik.setFieldValue("temporary_exemption_netsuite_ids", finalGroups);
    }
  }, [detail]);

  const ModuleType = [
    { value: "Information", label: "Information" },
    { value: "Mentored", label: "Mentored" },
    { value: "Orientation", label: "Orientation" },
    { value: "Scheduled", label: "Scheduled" },
  ];
  const ModuleTerm = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
  ];
  const ModuleYear = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
  ]
  const Type = [
    { value: "core", label: "Core" },
    { value: "specialised", label: "Specialised" },
    { value: "foundation", label: "Foundation" },
    { value: "no-barring", label: "Non-Credit Bearing" },
  ]
  const dot = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',

    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10,
    },
  });

  const modifiyOptionsForSelect = (arr, type = '') => {
    let modifiedArr = [];
    if (
      type == 'courseType' ||
      type == 'studyType' ||
      type == 'correspondence'
    ) {
      Object.keys(arr).map((key, index) => {
        modifiedArr.push({ value: arr[key], label: arr[key], key: key });
      });
    } else if (
      type == 'lecturer' ||
      type == 'programCoordinator' ||
      type == 'programSupport'
    ) {
      arr.map((ele) => {
        modifiedArr.push({ value: ele.name, label: ele.name, id: ele.UserID });
      });
    } else if (type == 'intakeYear') {
      arr.map((ele) => {
        modifiedArr.push({ value: ele.year, label: ele.year });
      });
      modifiedArr.sort(function (a, b) {
        return b.value - a.value;
      });
    } else if (type == 'intakeNumber') {
      Object.keys(arr).map((key, index) => {
        modifiedArr.push({ value: key, label: key });
      });
    } else if (type == 'crm') {
      arr.map((elem) => {
        modifiedArr.push({
          value: elem[1] + ' (' + elem[4] + ') ' + elem[2],
          label: elem[1] + ' (' + elem[4] + ') ' + elem[2],
          id: elem[0],
        });
      });
    } else if (type === 'netsuite') {
      arr.map((elem) => {
        modifiedArr.push({
          value: elem.id,
          label: elem.displayname,
          department: elem.department
        });
      });
    }

    return modifiedArr;
  };

  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      let background = RenderPMCStatus(data.value).bgColor;
      let color = RenderPMCStatus(data.value).colorCode;

      return {
        ...styles,
        backgroundColor: background,
        color: color,
        cursor: isDisabled ? 'not-allowed' : 'default',
      };
    },
  };

  // All saved IDs across all groups
  const savedIds = React.useMemo(() => {
    return formik.values.exemption_netsuite_ids
      .flat()
      .map(item => item.netsuite_id);
  }, [formik.values.exemption_netsuite_ids,detail]);

  // Get filtered options for a specific index
  const getFilteredOptions = (index) => {
    // IDs selected in the current group except current index
    const currentSelected = netsuitFormik.values.products
      .filter((_, idx) => idx !== index)
      .map(prod => prod.netsuite_product)
      .filter(Boolean);

    // Combine all excluded IDs
    const excluded = new Set([...currentSelected, ...savedIds].map(id => id.toString()));
    // Filter and map to Select options
    let excludeNetSuitId = netsuiteList.filter(item => !excluded.has(item.id.toString())) || [];
    return modifiyOptionsForSelect(
      excludeNetSuitId,
      'netsuite'
    );
  };

  const handleSaveNetsuit = () => {
    const { modelOpenFrom, products } = netsuitFormik.values;
    const { exemption_netsuite_ids } = formik.values;

    // Filter valid products (non-empty)
    const validProducts = products.filter(item => item.netsuite_product);

    if (validProducts.length === 0) {
      $("#netsuit-model").modal("hide");
      return;
    }
    
    let updatedGroups;

    if (modelOpenFrom === "click") {
      // Editing an existing group
      const currentGroupId = products[0]?.group_id;

      updatedGroups = exemption_netsuite_ids.map(groupArr => {
        // Check if this is the group we're editing
        if (groupArr.length > 0 && groupArr[0].group_number === currentGroupId) {
          // Create updated group items while preserving IDs
          return validProducts.map(item => {
            // Try to find existing item in the original group to preserve ID
            const existingItem = groupArr.find(existing =>
              existing.netsuite_id === item.netsuite_product
            );

            return {
              netsuite_id: item.netsuite_product,
              group_number: currentGroupId,
              id: existingItem ? existingItem.id : item.id || "" // Preserve existing ID
            };
          });
        }
        return groupArr; // Return unchanged group
      });
    } else {
      // Adding a new group
      const lastGroupId = exemption_netsuite_ids.length
        ? exemption_netsuite_ids[exemption_netsuite_ids.length - 1][0].group_number
        : 0;

      const newGroupId = deletedCombinationGroupIds.includes(lastGroupId)
        ? Math.max(...deletedCombinationGroupIds) + 1
        : lastGroupId + 1;

      const newGroup = validProducts.map(item => ({
        netsuite_id: item.netsuite_product,
        group_number: newGroupId,
        id: "" // New group, no existing ID
      }));

      updatedGroups = [...exemption_netsuite_ids, newGroup];
    }

    // Update the main form's exemption data
    formik.setFieldValue("exemption_netsuite_ids", updatedGroups);

    // Reset modal state
    netsuitFormik.setFieldValue("products", [
      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" },
      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" }
    ]);
    netsuitFormik.setFieldValue("modelOpenFrom", "plus");
    setSelectedProductData([
      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" },
      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" }
    ]);
    $("#netsuit-model").modal("hide");
  };

  // Formik for netsuit modal
  const netsuitFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      products: [
        { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" },
        { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" }
      ],
      modelOpenFrom: "plus"
    },
    validationSchema: Yup.object({
      products: Yup.array()
        .of(
          Yup.object({
            netsuite_product: Yup.string().nullable(),
            netsuiteProductName: Yup.string().nullable(),
            netsuite_department_id: Yup.string().nullable(),
          })
        )
        .test(
          "at-least-one",
          "At least one product is required",
          (products) => products?.some(p => p.netsuite_product?.trim() !== "")
        )
    }), onSubmit: (values, { resetForm, setErrors }) => {
      const hasSelected = values.products.some((p) => p.netsuite_product?.trim() !== "");

      if (!hasSelected) {
        // Set error without checking touched
        setErrors({ products: 'At least one product is required' });
        return;
      }
      handleSaveNetsuit(values.products);

      resetForm({
        values: {
          products: [
            { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "" },
            { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "" }
          ]
        }
      });
    }
  });

  function getGroupOptions(netsuiteList = [], groups = []) {
    // Return empty array if data isn't ready 
    if ((!netsuiteList || netsuiteList.length === 0 || !groups || groups.length === 0)) {
      return [];
    }
    const nameMap = Object.fromEntries(netsuiteList?.map(i => [i.id, i.displayname]));
    return groups?.length && groups?.map((group, index) => {
      const label = group?.length && group?.map(obj => nameMap[obj.netsuite_id] || '')
        ?.filter(Boolean)
        ?.join(" + ");

      return {
        value: index,
        label,
        ids: group?.length ? group.map(obj => obj.netsuite_id) : [],
        selectedGroup: group?.length ? group.map(obj => ({ "id": obj.id, "netsuite_id": obj.netsuite_id, "group_number": obj.group_number })) : {}
      };
    });
  }

  const groupOptions = React.useMemo(
    () => getGroupOptions(netsuiteList, formik.values.exemption_netsuite_ids),
    [netsuiteList, formik.values.exemption_netsuite_ids, detail]
  );

  // Function to filter exemptedCombination and set in products
  const handleExemptionSelect = (selectedObject) => {
    if (!selectedObject?.option) return;

    const optionIds = selectedObject.option.map(String);

    const matchingCombinations = exemptedCombination.filter(combination =>
      optionIds.includes(String(combination.id))
    );

    const updatedProducts = matchingCombinations.map(combination => {
      // find id from selectedObject.groupObj based on netsuite_id
      const groupObjItem = selectedObject.groupObj.find(
        obj => String(obj.netsuite_id) === String(combination.id)
      );

      return {
        netsuite_product: combination.id || "",
        netsuiteProductName: combination.displayname || combination.name || "",
        netsuite_department_id: combination.department || "",
        group_id: selectedObject.groupObj[0]?.group_number || "",
        id: groupObjItem ? groupObjItem.id : ""
      };
    });

    // Ensure minimum 2 rows
    while (updatedProducts.length < 2) {
      updatedProducts.push({
        netsuite_product: "",
        netsuiteProductName: "",
        netsuite_department_id: "",
        group_id: selectedObject.groupObj[0]?.group_number || "", // Same group_id for empty rows
        id: ""
      });
    }
    setSelectedProductData(updatedProducts);
    netsuitFormik.setFieldValue("products", updatedProducts);
    netsuitFormik.setFieldValue("modelOpenFrom", "click");
    $("#netsuit-model").modal("show");
  };

  const handleRemoveGroup = (groupIdToRemove) => {
    const { exemption_netsuite_ids, temporary_exemption_netsuite_ids } = formik.values;

    // Remove the selected group
    const filteredGroups = exemption_netsuite_ids.filter(
      groupArr => groupArr[0].group_number !== groupIdToRemove
    );

    // Find the max saved group number → numbering for new groups starts after this
    const maxSavedGroupNum = temporary_exemption_netsuite_ids.length
      ? Math.max(...temporary_exemption_netsuite_ids.map(g => g[0].group_number))
      : 0;

    let newGroups = [];
    let newCounter = maxSavedGroupNum + 1; // start numbering new groups fresh

    filteredGroups.forEach(groupArr => {
      const groupNum = groupArr[0].group_number;
      const isOld = temporary_exemption_netsuite_ids.some(
        oldGroup => oldGroup[0].group_number === groupNum
      );

      if (isOld) {
        // Keep old groups as they are
        newGroups.push(groupArr);
      } else {
        // Renumber all new groups sequentially after last saved
        newGroups.push(
          groupArr.map(item => ({
            netsuite_id: item.netsuite_id,
            group_number: newCounter
          }))
        );
        newCounter++;
      }
    });

    // Add deleted old groups to list
    const isOldGroup = temporary_exemption_netsuite_ids.some(
      oldGroup => oldGroup[0].group_number === groupIdToRemove
    );
    if (isOldGroup) {
      setDeletedCombinationGroupIds(prev => [...prev, groupIdToRemove]);
    }
    formik.setFieldValue("exemption_netsuite_ids", newGroups);
  };

  const handleUpdateExemption = async () => {
    // cancel all previous requests
    cancelSourcesRef.current.forEach(src => src.cancel("New request made"));
    cancelSourcesRef.current = [];

    const source = axios.CancelToken.source();
    cancelSourcesRef.current.push(source);

    try {
      const data = await updateExemptionModule({ MId: id }, source.token);

      if (data.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated Successfully",
        });
        setReload(Date.now());
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data || "Something went wrong",
        });
      }
    }
  };

  // cleanup when component unmounts
  useEffect(() => {
    return () => {
      cancelSourcesRef.current.forEach(src => src.cancel("Component unmounted"));
    };
  }, []);

  return (
    <div className="card card-profile-info-card">
      <div className="">
        <div className="card-body-inr card-body-info">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3">
                  <label>Portal Name *</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.errors.Portal && formik.touched.Portal
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter portal name"
                    name="Portal"
                    id="portalName"
                    title="Portal Name"
                    value={formik.values.Portal}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Status">
                  <label>Status *</label>
                  <Select
                    styles={colourStyles}
                    className={
                      "form-control color-drop custom-select-box" +
                      (formik.errors.module_status &&
                        formik.touched.module_status
                        ? " is-invalid"
                        : "")
                    }
                    name="status"
                    value={statusArr?.filter(val => val?.value === formik.values.module_status)}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue("module_status", value.value)
                      } else {
                        formik.setFieldValue("module_status", "")
                      }
                    }}
                    onBlur={formik.handleBlur}
                    options={statusArr}
                    maxMenuHeight={175}
                    placeholder={
                      formik.values.module_status
                        ? formik.values.module_status
                        : "Select Status  "
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3">
                  <label htmlFor="code">Code *</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.errors.Code && formik.touched.Code
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter code"
                    name="Code"
                    id="code"
                    title="Code"
                    maxLength={20}
                    value={formik.values.Code}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Duration">
                  <label>Duration (Weeks)</label>

                  <Select
                    className={
                      "form-control custom-select-box" +
                      (formik.errors.Duration && formik.touched.Duration
                        ? " is-invalid"
                        : "")
                    }
                    name="Duration"
                    value={modalDuration?.filter(val => val.value === formik.values.Duration)}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue("Duration", value.value)
                      } else {
                        formik.setFieldValue("Duration", "")
                      }
                    }}
                    onBlur={formik.handleBlur}
                    options={modalDuration}
                    maxMenuHeight={175}
                    placeholder={
                      formik.values.Duration
                        ? formik.values.Duration
                        : "Select Duration  "
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3">
                  <label>Marketing Name</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.errors.Marketing_Name &&
                        formik.touched.Marketing_Name
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter marketing name"
                    title="Enter marketing name"
                    name="Marketing_Name"
                    value={formik.values.Marketing_Name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3">
                  <label>Credits</label>
                  <input
                    type="number"
                    className={
                      "form-control" +
                      (formik.errors.credits && formik.touched.credits
                        ? " is-invalid"
                        : "")
                    }
                    placeholder="Enter credits"
                    title="Enter credits"
                    name="credits"
                    value={formik.values.credits}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Term">
                  <label>Semester/Term *</label>
                  <Select
                    isSearchable={false}
                    className={
                      "form-control custom-select-box" +
                      (formik.errors.term && formik.touched.term
                        ? " is-invalid"
                        : "")
                    }
                    name="term"
                    value={ModuleTerm.filter((val) =>
                      formik.values?.term?.includes(val.value)
                    )}
                    onChange={(value) => {
                      formik.setFieldValue(
                        "term",
                        value ? value.map((v) => v.value) : []
                      );
                    }}
                    onBlur={formik.handleBlur}
                    options={ModuleTerm}
                    maxMenuHeight={175}
                    isMulti={true}
                    placeholder={
                      formik.values.term ? formik.values.term : "Select Term"
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Year">
                  <label>Year *</label>
                  <Select
                    className={
                      "form-control custom-select-box" +
                      (formik.errors.year && formik.touched.year
                        ? " is-invalid"
                        : "")
                    }
                    name="year"
                    value={ModuleYear.filter((data) => {
                      return data.value === formik.values.year;
                    })}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue("year", value.value)
                      } else {
                        formik.setFieldValue("year", "")
                      }
                    }}
                    onBlur={formik.handleBlur}
                    options={ModuleYear}
                    maxMenuHeight={175}
                    placeholder={
                      formik.values.year ? formik.values.year : "Select Year"
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Type">
                  <label>Type *</label>
                  <Select
                    className={
                      "form-control custom-select-box" +
                      (formik.errors.type && formik.touched.type
                        ? " is-invalid"
                        : "")
                    }
                    name="type"
                    value={Type.filter((data) => {
                      return data.value === formik.values.type;
                    })}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue("type", value.value)
                      } else {
                        formik.setFieldValue("type", "")
                      }
                    }}
                    onBlur={formik.handleBlur}
                    options={Type}
                    maxMenuHeight={175}
                    placeholder={
                      formik.values.type ? formik.values.type : "Select Type"
                    }
                    isClearable
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Pre-Requisites">
                  <label>Pre-Requisites</label>
                  <Select
                    className="form-control custom-select-box is-multi"
                    name="pre_requisites"
                    value={moduleList.filter((data) => {
                      return formik.values.pre_requisites && formik.values.pre_requisites.includes(data.value);
                    })}
                    onChange={(value) => {
                      let valArr = [];

                      if (value && value.length > 0) {
                        const hasNone = value.some(item => item.value === 0);
                        const hasValid = value.some(item => item.value !== 0);

                        if (isPreReqNone && hasValid) {
                          valArr = value.filter(item => item.value !== 0);
                          setIsPreReqNone(false);
                        } else if (hasNone) {
                          valArr = [{ label: "None", value: 0 }];
                          setIsPreReqNone(true);
                        } else {
                          valArr = value;
                        }
                      }
                      formik.setFieldValue("pre_requisites", valArr ? valArr.map(item => item.value) : []);
                    }}
                    onBlur={formik.handleBlur}
                    options={moduleList}
                    maxMenuHeight={175}
                    isMulti={true}
                    placeholder="Select Pre-Requisites"
                    components={{
                      MultiValueLabel: ({ data, ...props }) => (
                        <div className="css-12jo7m5" title={data.label} {...props}>
                          {props.children}
                        </div>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-group-blk mb-3" title="Co-Requisites">
                  <label>Co-Requisites</label>
                  <Select
                    className={
                      "form-control custom-select-box is-multi"
                    }
                    name="co_requisites"
                    value={moduleList.filter((data) => {
                      return formik.values.co_requisites && formik.values.co_requisites.includes(data.value);
                    })}
                    onChange={(value) => {
                      let valArr = [];

                      if (value && value.length > 0) {
                        const hasNone = value.some(item => item.value === 0);
                        const hasValid = value.some(item => item.value !== 0);

                        if (isCoreqNone && hasValid) {
                          valArr = value.filter(obj => obj.value !== 0);
                          setIsCoreqNone(false);
                        } else if (hasNone && !hasValid) {
                          valArr = [{ label: "None", value: 0 }];
                          setIsCoreqNone(true);
                        } else {
                          valArr = value;
                          setIsCoreqNone(false);
                        }
                      }
                      formik.setFieldValue("co_requisites", valArr ? valArr.map(obj => obj.value) : []);
                    }}
                    onBlur={formik.handleBlur}
                    options={moduleList}
                    maxMenuHeight={175}
                    isMulti={true}
                    placeholder="Select Co-Requisites"
                    components={{
                      MultiValueLabel: ({ data, ...props }) => (
                        <div className="css-12jo7m5" title={data.label} {...props}>
                          {props.children}
                        </div>
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="form-icon-group mb-4 d-block" title="Netsuite Product">
                  <label>Netsuite Product</label>
                  <Select
                    className={
                      'form-control custom-select-box' +
                      (formik.errors.netsuite_product &&
                        formik.touched.netsuite_product
                        ? ' is-invalid'
                        : '')
                    }
                    name="netsuite_product"
                    value={modifiyOptionsForSelect(netsuiteList.filter((data) => data.id == formik.values.netsuite_product), "netsuite")}
                    onChange={(value) => {
                      if (value) {
                        formik.setFieldValue(
                          'netsuite_product',
                          value.value
                        );
                        formik.setFieldValue(
                          'netsuiteProductName',
                          value.label
                        );
                        formik.setFieldValue(
                          'netsuite_department_id',
                          value.department
                        )
                      } else {
                        formik.setFieldValue('netsuite_product', '');
                        formik.setFieldValue(
                          'netsuiteProductName',
                          ''
                        );
                      }
                    }}
                    isClearable
                    onBlur={formik.handleBlur}
                    options={
                      netsuiteList
                        ? modifiyOptionsForSelect(
                          netsuiteList,
                          'netsuite'
                        )
                        : []
                    }
                    maxMenuHeight={175}
                    placeholder={
                      formik.values.netsuiteProductName
                        ? formik.values.netsuiteProductName
                        : 'Netsuite Product'
                    }
                  />
                </div>
              </div>
              <div className="col-12 mb-3">
                <label htmlFor="legacyModule" title="Legacy modules for exemption">
                  Legacy modules for exemption
                  <i className="fal fa-info-circle ml-1" title="Defined netsuite items that if a student has a pass for it/them, would be granted exemption for this module"></i>
                </label>
                <div className="d-flex w-100 align-items-center">
                  <div
                    className="form-group-blk"
                    style={{ flex: '1 1 0', minWidth: 0 }}
                    title="Legacy modules for exemption"
                    id="legacyModule"
                  >
                    <Select
                      className="form-control custom-select-box"
                      name="exemption_netsuite_ids"
                      value={groupOptions?.length ?  groupOptions.map((option, index) => ({
                        label: option.label,
                        value: option.id,
                        option:option.ids,
                        group_id : index + 1,
                        groupObj : option?.selectedGroup
                      })) : []}
                      options={groupOptions || []}
                      isMulti
                      placeholder="Exemptions List"
                      isClearable={false}
                      isSearchable={false}
                      menuIsOpen={false}
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          flexWrap: 'wrap',
                          overflow: "visible",
                          alignItems: "flex-start",
                          whiteSpace: "normal"
                        }),
                        multiValueLabel: (provided) => ({
                          ...provided,
                          whiteSpace: 'wrap',
                          overflow: "visible",
                        })
                      }}
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                        MultiValueRemove: ({ data }) => (
                          <PermissionsGate scopes={["pmcversionexemptionsdelete"]} RenderError={() => null}>
                            <span
                              className="custom-remove-icon remove-exempted-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveGroup(data.groupObj[0]?.group_number);
                              }}
                            >
                              <i className="fal fa-times"></i>
                            </span>
                          </PermissionsGate>
                        ),
                        MultiValueLabel: ({ data, ...props }) => (
                          <div
                            className="css-12jo7m5 cursor-pointer"
                            title={data.label}
                            style={{
                              whiteSpace: 'wrap',
                            }}
                            onClick={() => handleExemptionSelect(data)}
                            {...props}
                          >
                            {props.children}
                          </div>
                        ),
                      }}
                    />
                  </div>
                  <PermissionsGate scopes={["pmcversionexemptionsadd"]} errorProps={{ disabled: true }}>

                    <button
                      type="button"
                      className="btn btn-primary rounded-circle ml-3"
                      style={{ flexShrink: 0 }}
                      title="Add exemption or exemption combination"
                      data-toggle="modal"
                      data-target="#netsuit-model"
                    >
                      <i className="fal fa-plus"></i>
                    </button>
                  </PermissionsGate>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group-blk mb-3">
                  <div style={{ display: "none" }}>{description}</div>
                  <label>Description</label>
                  {isEditorStateReady || type == "add" ? <HtmlInputEditor
                    editorState={description}
                    setEditorState={setDescription}
                    hideSign={true}
                    isCKEditor={true}
                  /> : ""}
                </div>
              </div>
            </div>
            <div className="form-group form-group-save-cancel mt-4 align-items-start">
              <button
                className="btn btn-save btn-success"
                type="submit"
                title="Save"
                disabled={disabled}
              >
                {disabled ? (
                  <i className="fas fa-cog fa-spin"></i>
                ) : (
                  <i className="fal fa-save"></i>
                )}
                Save
              </button>
              <div className="d-flex flex-column mx-2">
                <PermissionsGate scopes={["pmcversionexemptionsdelete","pmcversionexemptionsadd"]}  errorProps={{disabled : true}}>
                  <button
                    className="btn btn-primary"
                    type="button"
                    title="Update Exemptions"
                    onClick={()=> handleUpdateExemption()}
                  >
                    <i className="fal fa-sync"></i>
                    Update Exemptions
                  </button>
                </PermissionsGate>

                 {detail && detail?.updateExemptBy && Object.keys(detail.updateExemptBy).length > 0 ? <div className='document_wrp align-items-start pt-2'>
                  <i className="fal fa-history history_btn pr-2" />
                  <small>
                    Updated on <strong>{moment.unix(detail?.update_exemption_date).format('DD MMM YY')}</strong> at <strong>{moment.unix(detail?.update_exemption_date).format('HH:mm')}</strong> by <strong>{detail?.updateExemptBy?.fullname}</strong>
                  </small>
                </div> : null}
              </div>
              <button
                className="btn btn-close btn-danger"
                type="button"
                title="Cancel"
                onClick={()=> {
                  formik.resetForm();
                  netsuitFormik.resetForm()
                }}
              >
                <i className="fal fa-times"></i>Cancel
              </button>
            </div>

            {Object.keys(formik.values).map(key => {
              if (formik.touched[key] && formik.errors[key]) {
                return (
                  <div className="invalid-feedback d-block">
                    {formik.errors[key]}
                  </div>
                )
              }
            })}
          </form>
        </div>
      </div>
      {/* netsuit model */}
      <div
        className="topic-add-modal modal fade"
        id="netsuit-model"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false" 
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content modal-border-update">
            <FormikProvider value={netsuitFormik}>
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">
                  <i className="fal fa-plus"></i> Add NetSuite Products for Exemptions
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setSelectedProductData([
                      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" },
                      { netsuite_product: "", netsuiteProductName: "", netsuite_department_id: "", group_id: "", id: "" }
                    ]);
                    netsuitFormik.resetForm();
                  }}
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <FieldArray
                  name="products"
                  render={(arrayHelpers) => (
                    <form onSubmit={netsuitFormik.handleSubmit}>
                      {netsuitFormik.values.products.map((product, index) => (
                        <div key={index} className="row">
                          <div className="col-12">
                            <div className="d-flex w-100">
                              <div className="form-group-blk mb-2 w-100" title="NetSuite Products">
                                <Select
                                  className={
                                    'form-control custom-select-box' +
                                    (netsuitFormik.errors.products ? ' is-invalid' : '')
                                  }
                                  name={`products[${index}].netsuite_product`}
                                  value={
                                    product.netsuite_product
                                      ? modifiyOptionsForSelect(
                                        exemptedCombination.filter((data) => data.id == product.netsuite_product),
                                        "netsuite"
                                      )[0]
                                      : null
                                  }
                                  onChange={(value) => {
                                    if (value) {
                                    // Trigger validation after field change
                                    setTimeout(() => {
                                      netsuitFormik.validateForm();
                                    }, 0);
                                      netsuitFormik.setFieldValue(`products[${index}].netsuite_product`, value.value);
                                      netsuitFormik.setFieldValue(`products[${index}].netsuiteProductName`, value.label);
                                      netsuitFormik.setFieldValue(`products[${index}].netsuite_department_id`, value.department);
                                    } else {
                                      netsuitFormik.setFieldValue(`products[${index}].netsuite_product`, '');
                                      netsuitFormik.setFieldValue(`products[${index}].netsuiteProductName`, '');
                                      netsuitFormik.setFieldValue(`products[${index}].netsuite_department_id`, '');
                                    }
                                    // Trigger validation after field change
                                    setTimeout(() => {
                                      netsuitFormik.validateForm();
                                    }, 0);
                                  }}
                                  isClearable
                                  onBlur={() => netsuitFormik.setFieldTouched(`products[${index}].netsuite_product`, true)}
                                  options={netsuiteList ? getFilteredOptions(index) : []}
                                  maxMenuHeight={175}
                                  placeholder={'Select'}
                                />
                              </div>
                              {/* Delete button */}
                              <button
                                type="button"
                                title="Delete"
                                className="btn btn-danger rounded-circle my-2 ml-3"
                                onClick={() => {
                                  const updatedProducts = [...netsuitFormik.values.products];
                                  updatedProducts.splice(index, 1); 
                                  netsuitFormik.setFieldValue("products", updatedProducts);
                                }}
                                disabled={netsuitFormik.values.products.length <= 1}
                              >
                                <i className="fal fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                          {index < netsuitFormik.values.products?.length - 1 && <div className="col-12 pt-2 pb-3 justify-content-center d-flex align-items-center">
                            <i className="fal fa-plus" title="Exemption is granted only when all selected products have been passed or exempted"></i>
                          </div>}
                        </div>
                      ))}

                      {/* Add button */}
                      <button
                        title="Add additional Product"
                        type="button"
                        className="btn btn-link px-0"
                        onClick={() => arrayHelpers.push({})}
                      >
                        Add additional Product <i className="fal fa-plus"></i>
                      </button>

                      <div className="form-group form-group-save-cancel mt-4 align-items-start">
                        <button
                          className="btn btn-save btn-success"
                          type="submit" 
                          title="Save"
                          disabled={disabled}
                        >
                          {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
                          Save
                        </button>


                        <button
                          className="btn btn-close btn-danger"
                          type="button"
                          title="Cancel"
                          onClick={() => {
                            if (selectedProductData[0].netsuite_product) {
                              netsuitFormik.setFieldValue("products", selectedProductData);
                            } else {
                              netsuitFormik.resetForm()
                            }
                          }
                          }
                        >
                          <i className="fal fa-times"></i>Cancel
                        </button>
                      </div>
                     {/* Display array-level error - NO touched condition */}
                      {typeof netsuitFormik.errors.products === 'string' && (
                        <div className="invalid-feedback d-block">
                          {netsuitFormik.errors.products}
                        </div>
                      )}

                      {/* Display individual field errors - NO touched condition */}
                      {Array.isArray(netsuitFormik.errors.products) &&
                        netsuitFormik.errors.products.map((prodError, index) => (
                          prodError?.netsuite_product && (
                            <div key={index} className="invalid-feedback d-block">
                              {prodError.netsuite_product}
                            </div>
                          )
                        ))
                      }

                    </form>
                  )}
                />
              </div>
            </FormikProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleDetail;
